/* eslint-disable no-unused-vars */

import React, { useEffect } from 'react';
import whystillpic from './assets/Whystill.jpeg';
import './WhyShush.css';

const WhyShush = () => {
  useEffect(() => {
    const items = document.querySelectorAll('.whylist li');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target); // animate once
          }
        });
      },
      { threshold: 0.3 }
    );
    items.forEach((item) => observer.observe(item));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="whyshush">
      <div className="whylist">
        <h2>Why STILL</h2>
        <ul>
          <li>
            <h3>ARCHITECTURAL DESIGN</h3>
            <p>Timeless elegance. Not trend-chasing.</p>
          </li>
          <li>
            <h3>GUARANTEED FIT</h3>
            <p>FitTech precision. No guessing. No returns.</p>
          </li>
          <li>
            <h3>ACCESSIBLE LUXURY</h3>
            <p>Premium craftsmanship at a fair price.</p>
          </li>
          <li>
            <h3>WOMAN APPROVED</h3>
            <p>Designed, worn and refined through real-world testing.</p>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default WhyShush;
